import LTR from "@brand-icons/ploomg4/hand-dobble/hand-dobble-ltr.svg";
import RTL from "@brand-icons/ploomg4/hand-dobble/hand-dobble-rtl.svg";

import { iconFactory } from "../iconFactory";

export const HandDobbleIcon = iconFactory("HandDobbleIcon", LTR, RTL);
